import dayjs from 'dayjs'
import customParseFormat from 'dayjs/plugin/customParseFormat.js'
import type { ParcelShopLocationDto } from '@dhl/servicepoint-locator-api'
import type { Servicepoint, ServicepointFormat, ServicepointType, ServiceType } from './model.js'

// FIXME: this is global, not what we want
dayjs.extend(customParseFormat)

export const toServiceType = (input: string): ServiceType | undefined => {
  switch (input) {
    case 'parcel-first-mile':
      return 'ParcelFirstMile'
    case 'parcel-last-mile':
      return 'ParcelLastMile'
    default:
      return undefined
  }
}

export const toServicepointType = (input: string): ServicepointType => {
  switch (input) {
    case 'packStation':
      return 'PackStation'
    case 'parcelShop':
    case 'paketShop':
    case 'postBank':
    case 'postOffice':
      return 'Servicepoint'
    default:
      throw new Error(`Unknown servicepoint type: ${input}`)
  }
}

const convertToTime = (input: string): dayjs.Dayjs => dayjs(input, 'H:mm:ss.SSS')

export const mapParcelShopLocationToServicepoint = (item: ParcelShopLocationDto): Servicepoint => ({
  servicepointKey: item.psfKey,
  servicepointType: toServicepointType(item.shopType),
  servicepointFormat: item.servicepointFormat as ServicepointFormat,
  shopType: item.shopType,
  name: item.name,
  distance: item.distance,
  isLocker:
    item.shopType === 'packStation' ||
    item.servicepointFormat === 'Pakketautomaat DeBuren' ||
    item.servicepointFormat === 'Pakketautomaat SmartMile' ||
    item.servicepointFormat === 'DHL Pakketautomaat',
  serviceTypes: item.serviceTypes?.map(toServiceType).filter(Boolean) as ServiceType[],
  geoLocation: item.geoLocation,
  openingsTimes:
    item.openingTimes?.map((openingTime) => ({
      weekDay: openingTime.weekDay,
      timeFrom: convertToTime(openingTime.timeFrom),
      timeTo: convertToTime(openingTime.timeTo),
    })) ?? [],
  address: {
    countryCode: item.address.countryCode,
    street: item.address.street,
    city: item.address.city,
    houseNumber: item.address.number,
    houseNumberSuffix: item.address.addition ?? '',
    postalCode: item.address.zipCode,
    suburb: '',
  },
  depotCode: item.depotCode,
})
